/* eslint-disable no-console */

/**
 * Service Worker bootstrap.
 *
 * Historicamente a SPA usava @vue/cli-plugin-pwa para gerar um SW com
 * pre-caching de chunks JS/CSS. Em deploys isso causava ChunkLoadError
 * porque clients antigos cacheavam HTML/JS antigos e o browser nunca
 * baixava as versoes novas.
 *
 * Agora registramos um SW MINIMO em public/sw.js que NAO intercepta
 * fetches nem faz caching. Ele existe apenas para suportar push
 * notifications via navigator.serviceWorker.getRegistration() em
 * src/services/notification.js, src/components/chat-popup.vue e
 * src/router/views/workspace-canais-equipe.vue.
 *
 * Caches deixados pela versao PWA antiga sao limpos no boot pra
 * nao servirem chunks velhos. O register em si eh idempotente — se
 * services/notification.js ja registrou, o browser reusa a mesma
 * registration.
 *
 * Fixes AAWZ-WEB-3VT
 */

export async function clearLegacyCaches(globalScope = globalThis) {
  if (
    !globalScope ||
    !globalScope.caches ||
    typeof globalScope.caches.keys !== 'function' ||
    typeof globalScope.caches.delete !== 'function'
  ) {
    return { cleared: 0 }
  }
  try {
    const keys = await globalScope.caches.keys()
    let cleared = 0
    for (const key of keys) {
      try {
        const ok = await globalScope.caches.delete(key)
        if (ok) cleared += 1
      } catch (err) {
        console.warn('[SW] Falha ao limpar cache', key, err)
      }
    }
    if (cleared > 0) console.log(`[SW] Limpou ${cleared} cache(s) legados`)
    return { cleared }
  } catch (err) {
    console.warn('[SW] caches.keys falhou:', err)
    return { cleared: 0 }
  }
}

export async function registerMinimalServiceWorker(
  nav = globalThis.navigator,
  baseUrl = '/'
) {
  if (
    !nav ||
    !nav.serviceWorker ||
    typeof nav.serviceWorker.register !== 'function'
  ) {
    return null
  }
  const url = `${baseUrl || '/'}sw.js`
  try {
    const reg = await nav.serviceWorker.register(url)
    console.log('[SW] Service worker minimal registrado em', url)
    return reg
  } catch (err) {
    console.warn('[SW] Falha ao registrar service worker:', err)
    return null
  }
}

clearLegacyCaches()
registerMinimalServiceWorker(globalThis.navigator, process.env.BASE_URL)
